import { useState, useEffect } from "react";
import { useNavigate } from "react-router";

//import material ui
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Tooltip,
  Pagination,
  TablePagination,
  Fab,
  Stack,
  TextField,
  InputAdornment,
  CircularProgress,
  Select,
  MenuItem,
  Autocomplete,
} from "@mui/material";
//Icons
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import FilterListIcon from "@mui/icons-material/FilterList";
import ArticleIcon from "@mui/icons-material/Article";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import CloseIcon from "@mui/icons-material/Close";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";

//project components
import config from "../../../config";

//third party
import useAxiosAuth from "../../../hooks/useAxiosAuth";
import { Box } from "@mui/system";
import EmployerForm from "./EmployerForm";
import NoDataFound from "../../../components/NoDataFound";
import {
  convertDateToLocal,
  convertDateToLocalReverse,
} from "../../../utils/date-operations";

const Employers = () => {
  //Constants
  const navigate = useNavigate();
  const axiosAuth = useAxiosAuth();
  const pageSize = 50;
  //States
  const [checked, setChecked] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openRestoreConfirmation, setOpenRestoreConfirmation] = useState(false);
  const [employers, setEmployers] = useState();
  const [deletedEmployers, setDeletedEmployers] = useState();
  const [selectedEmployer, setSelectedEmployer] = useState();
  const [openEmployerForm, setOpenEmployerForm] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [registrationStatus, setRegistrationStatus] = useState(0);
  const [specialization, setSpecialization] = useState("");
  const [specializationOptions, setSpecializationOptions] = useState([]);

  //Methods
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const getEmployers = (skip) => {
    if (checked) {
      axiosAuth
        .get("/api/Employers/GetDeleted-Employer?skip=0&take=" + pageSize)
        .then((response) => {
          setEmployers(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axiosAuth
        .get(
          "/api/Employers/list?searchText=" +
            searchText +
            "&registrationStatus=" +
            registrationStatus +
            "&specialization=" +
            specialization +
            "&skip=" +
            skip +
            "&take=" +
            pageSize
        )
        .then((response) => {
          setEmployers(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleCancelDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = () => {
    axiosAuth
      .delete("/api/Employers/soft-delete?id=" + selectedEmployer.id)
      .then((response) => {
        if (response.status === 200) {
          getEmployers(0);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setOpenDelete(false);
  };

  const handleRestore = () => {
    axiosAuth
      .delete("/api/Employers/restore?id=" + selectedEmployer.id)
      .then((response) => {
        if (response.status === 200) {
          getEmployers(0);
          setOpenRestoreConfirmation(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setOpenDelete(false);
  };

  //UseEffects
  useEffect(() => {
    axiosAuth
      .get("/api/EmployerSpecialzationMasters/list?skip=0&take=1000000")
      .then((response) => setSpecializationOptions(response.data))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    getEmployers(0);
  }, [checked, searchText, registrationStatus, specialization]);

  return (
    <Grid maxWidth="xl" sx={{ marginX: "auto", paddingY: 4, paddingX: 2 }}>
      <Card elevation={3}>
        <Grid
          sx={{
            background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
            paddingX: 2,
            paddingY: 1,
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5" color="white.main">
              Employers
            </Typography>
            <Grid>
              <Tooltip title="Add New">
                <IconButton
                  color="white"
                  sx={{ marginLeft: 2 }}
                  onClick={() => {
                    navigate("/admin/employers/form");
                  }}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            {employers != undefined ? (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingX: 2,
                    paddingTop: 2,
                  }}
                >
                  <TextField
                    size="small"
                    disabled={checked}
                    fullWidth
                    placeholder="search by name,mobile number"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),

                      endAdornment: searchText != "" && (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => {
                              setSearchText("");
                              getEmployers(0);
                            }}
                            edge="end"
                          >
                            <CloseIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={3}
                  md={3}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingX: 2,
                    paddingTop: 2,
                  }}
                >
                  {" "}
                  <Select
                    fullWidth
                    size="small"
                    labelId="registration-status"
                    id="registration"
                    name="registrationStatus"
                    value={registrationStatus}
                    onChange={(e) => {
                      setRegistrationStatus(e.target.value);
                    }}
                  >
                    <MenuItem value={0}>All</MenuItem>
                    <MenuItem value={1}>Registered</MenuItem>
                    <MenuItem value={2}>Unregistered</MenuItem>
                  </Select>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={3}
                  md={3}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingX: 2,
                    paddingTop: 2,
                  }}
                >
                  <Autocomplete
                    fullWidth
                    size="small"
                    options={specializationOptions}
                    getOptionLabel={(option) => option.name ?? ""}
                    value={specializationOptions.find((o) => o.name === specialization) ?? null}
                    onChange={(_, selected) => {
                      setSpecialization(selected ? selected.name : "");
                    }}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Specialization" />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingX: 2,
                    paddingTop: 2,
                  }}
                >
                  <Box sx={{ margin: 1, padding: 1 }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox checked={checked} onChange={handleChange} />
                        }
                        label="Show deleted employers"
                      />
                    </FormGroup>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingRight: 2,
                    paddingTop: 2,
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Typography>Total: {employers.count}</Typography>
                    <Pagination
                      count={Math.ceil(employers.count / pageSize)}
                      variant="outlined"
                      shape="rounded"
                      showFirstButton
                      showLastButton
                      color="primary"
                      onChange={(event, page) => {
                        getEmployers((page - 1) * pageSize);
                      }}
                    />
                  </Stack>
                </Grid>
              </Grid>
            ) : null}
          </Grid>

          <Grid item xs={12}>
            {employers != undefined ? (
              employers.employers && employers.employers.length > 0 ? (
                <Box>
                  <Box
                    sx={{
                      display: { xs: "flex", md: "none" },
                      flexDirection: "column",
                    }}
                  >
                    {employers.employers.map((employer, index) => {
                      return (
                        <Card
                          key={index}
                          variant="outlined"
                          sx={{
                            margin: 1,
                            padding: 1,
                            display: "flex",
                            justifyContent: "space-between",
                            backgroundColor: "#F5F5F5",
                          }}
                        >
                          <Stack spacing={1}>
                            <Typography variant="h6">
                              <b>Name:</b> {employer.name}
                            </Typography>
                            <Typography>
                              <b>Email:</b> {employer.email}
                            </Typography>
                            <Typography>
                              <b>Phone No.:</b> {employer.phoneNumber}
                            </Typography>
                            <Typography>
                              <b>City:</b> {employer.city}
                            </Typography>
                            <Typography>
                              <b>Website:</b> {employer.website}
                            </Typography>
                          </Stack>
                          <Stack
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            {/* <Tooltip title="View Details">
                            <IconButton
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={() => {
                                navigate(
                                  "/admin/employer-details?id=" + employer.id
                                );
                              }}
                            >
                              <ArticleIcon fontSize="inherit" />
                            </IconButton>
                          </Tooltip> */}
                            <Tooltip title="Edit">
                              <IconButton
                                variant="outlined"
                                color="primary"
                                size="small"
                                onClick={() => {
                                  setSelectedEmployer(employer);
                                  navigate(
                                    "/admin/employers/form?Id=" + employer.id
                                  );
                                }}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                            </Tooltip>
                            {employer.isDeleted === true ? (
                              <Tooltip title="Restore">
                                <IconButton
                                  color="primary"
                                  size="small"
                                  onClick={() => {
                                    let tempEmployer = {
                                      id: employer.id,
                                      name: employer.name,
                                      email: employer.email,

                                      phoneNumber: employer.phoneNumber,
                                      addressLine1: employer.addressLine1,
                                      addressLine2: employer.addressLine2,
                                      city: employer.city,
                                      taluka: employer.taluka,
                                      district: employer.district,
                                      state: employer.state,
                                      pinCode: employer.pinCode,
                                      website: employer.website,
                                      createDate: convertDateToLocalReverse(
                                        employer.createDate
                                      ),
                                      modifiedDate: convertDateToLocalReverse(
                                        employer.modifiedDate
                                      ),
                                      isDeleted: employer.isDeleted,
                                      deleteDate: convertDateToLocalReverse(
                                        employer.deleteDate
                                      ),
                                      canDelete: employer.canDelete,
                                      gradeType: employer.gradeType,
                                      contactPerson1Name:
                                        employer.contactPerson1Name,
                                      contactPerson1PhoneNumber:
                                        employer.contactPerson1PhoneNumber,
                                      contactPerson1Email:
                                        employer.contactPerson1Email,
                                      contactPerson2Name:
                                        employer.contactPerson2Name,
                                      contactPerson2PhoneNumber:
                                        employer.contactPerson2PhoneNumber,
                                      contactPerson2Email:
                                        employer.contactPerson2Email,
                                      contactPerson3Name:
                                        employer.contactPerson3Name,
                                      contactPerson3PhoneNumber:
                                        employer.contactPerson3PhoneNumber,
                                      contactPerson3Email:
                                        employer.contactPerson3Email,
                                      contactPerson4Name:
                                        employer.contactPerson4Name,
                                      contactPerson4PhoneNumber:
                                        employer.contactPerson4PhoneNumber,
                                      contactPerson4Email:
                                        employer.contactPerson4Email,
                                      contactPerson5Name:
                                        employer.contactPerson5Name,
                                      contactPerson5PhoneNumber:
                                        employer.contactPerson5PhoneNumber,
                                      contactPerson5Email:
                                        employer.contactPerson5Email,
                                      latittude: employer.latittude,
                                      longitude: employer.longitude,
                                      landlineNumber: employer.landlineNumber,
                                    };
                                    setSelectedEmployer(tempEmployer);
                                    setOpenRestoreConfirmation(true);
                                  }}
                                >
                                  <SettingsBackupRestoreIcon fontSize="inherit" />
                                </IconButton>
                              </Tooltip>
                            ) : (
                              <Tooltip title="Delete">
                                <IconButton
                                  color="error"
                                  size="small"
                                  onClick={() => {
                                    let tempEmployer = {
                                      id: employer.id,
                                      name: employer.name,
                                      email: employer.email,

                                      phoneNumber: employer.phoneNumber,
                                      addressLine1: employer.addressLine1,
                                      addressLine2: employer.addressLine2,
                                      city: employer.city,
                                      taluka: employer.taluka,
                                      district: employer.district,
                                      state: employer.state,
                                      pinCode: employer.pinCode,
                                      website: employer.website,
                                      createDate: convertDateToLocalReverse(
                                        employer.createDate
                                      ),
                                      modifiedDate: convertDateToLocalReverse(
                                        employer.modifiedDate
                                      ),
                                      isDeleted: employer.isDeleted,
                                      deleteDate: convertDateToLocalReverse(
                                        employer.deleteDate
                                      ),
                                      canDelete: employer.canDelete,
                                      gradeType: employer.gradeType,
                                      contactPerson1Name:
                                        employer.contactPerson1Name,
                                      contactPerson1PhoneNumber:
                                        employer.contactPerson1PhoneNumber,
                                      contactPerson1Email:
                                        employer.contactPerson1Email,
                                      contactPerson2Name:
                                        employer.contactPerson2Name,
                                      contactPerson2PhoneNumber:
                                        employer.contactPerson2PhoneNumber,
                                      contactPerson2Email:
                                        employer.contactPerson2Email,
                                      contactPerson3Name:
                                        employer.contactPerson3Name,
                                      contactPerson3PhoneNumber:
                                        employer.contactPerson3PhoneNumber,
                                      contactPerson3Email:
                                        employer.contactPerson3Email,
                                      contactPerson4Name:
                                        employer.contactPerson4Name,
                                      contactPerson4PhoneNumber:
                                        employer.contactPerson4PhoneNumber,
                                      contactPerson4Email:
                                        employer.contactPerson4Email,
                                      contactPerson5Name:
                                        employer.contactPerson5Name,
                                      contactPerson5PhoneNumber:
                                        employer.contactPerson5PhoneNumber,
                                      contactPerson5Email:
                                        employer.contactPerson5Email,
                                      latittude: employer.latittude,
                                      longitude: employer.longitude,
                                      landlineNumber: employer.landlineNumber,
                                    };
                                    setSelectedEmployer(tempEmployer);
                                    setOpenDelete(true);
                                  }}
                                >
                                  <DeleteIcon fontSize="inherit" />
                                </IconButton>
                              </Tooltip>
                            )}
                            {/* <Typography>{employer.index}</Typography> */}
                          </Stack>
                        </Card>
                      );
                    })}
                  </Box>
                  <Box sx={{ display: { xs: "none", md: "flex" } }}>
                    <TableContainer sx={{ padding: 2 }}>
                      <Table
                        sx={{
                          borderWidth: 1,
                          border: "solid",
                          borderColor: "#f2f2f2",
                        }}
                        size="small"
                      >
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#e6eeff" }}>
                            <TableCell sx={{ width: 50 }}>#</TableCell>
                            <TableCell align="left">Employer Name</TableCell>
                            <TableCell align="left" sx={{ width: 120 }}>
                              Email
                            </TableCell>
                            <TableCell align="left" sx={{ width: 180 }}>
                              Phone No.
                            </TableCell>
                            <TableCell align="left" sx={{ width: 120 }}>
                              City
                            </TableCell>
                            <TableCell align="left" sx={{ width: 180 }}>
                              Specialization
                            </TableCell>
                            <TableCell align="left" sx={{ width: 120 }}>
                              Website
                            </TableCell>
                            <TableCell
                              align="right"
                              sx={{ width: 130 }}
                            ></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {employers.employers?.map((row, index) => (
                            <TableRow key={row.id}>
                              <TableCell component="th" scope="row">
                                {row.index}
                              </TableCell>
                              <TableCell align="left">
                                <Typography variant="h6">{row.name}</Typography>
                              </TableCell>
                              <TableCell align="left">
                                {row.email ? row.email : "--"}
                              </TableCell>
                              <TableCell align="left">
                                <Typography variant="body2">
                                  Mobile No.:{" "}
                                  {row.phoneNumber ? row.phoneNumber : "--"}
                                </Typography>
                                <Typography variant="body2">
                                  Landline:{" "}
                                  {row.landlineNumber
                                    ? row.landlineNumber
                                    : "--"}
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                {row.city ? row.city : "--"}
                              </TableCell>
                              <TableCell align="left">
                                {row.employerSpecializations?.length > 0
                                  ? row.employerSpecializations.map((s) => s.specializationName).join(", ")
                                  : "--"}
                              </TableCell>
                              <TableCell align="left">
                                {row.website ? row.website : "--"}
                              </TableCell>
                              <TableCell align="right">
                                <Tooltip title="Edit">
                                  <IconButton
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    onClick={() => {
                                      navigate(
                                        "/admin/employer-details?ref=" + row.id
                                      );
                                    }}
                                  >
                                    <ArticleIcon fontSize="inherit" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Edit">
                                  <IconButton
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    onClick={() => {
                                      setSelectedEmployer(row);
                                      navigate(
                                        "/admin/employers/form?Id=" + row.id
                                      );
                                    }}
                                  >
                                    <EditIcon fontSize="inherit" />
                                  </IconButton>
                                </Tooltip>
                                {row.isDeleted ? (
                                  <Tooltip title="Restore">
                                    <IconButton
                                      color="primary"
                                      size="small"
                                      onClick={() => {
                                        let tempEmployer = {
                                          id: row.id,
                                          name: row.name,
                                          email: row.email,

                                          phoneNumber: row.phoneNumber,
                                          addressLine1: row.addressLine1,
                                          addressLine2: row.addressLine2,
                                          city: row.city,
                                          taluka: row.taluka,
                                          district: row.district,
                                          state: row.state,
                                          pinCode: row.pinCode,
                                          website: row.website,
                                          createDate: convertDateToLocalReverse(
                                            row.createDate
                                          ),
                                          modifiedDate:
                                            convertDateToLocalReverse(
                                              row.modifiedDate
                                            ),
                                          isDeleted: row.isDeleted,
                                          deleteDate: convertDateToLocalReverse(
                                            row.deleteDate
                                          ),
                                          canDelete: row.canDelete,
                                          gradeType: row.gradeType,
                                          contactPerson1Name:
                                            row.contactPerson1Name,
                                          contactPerson1PhoneNumber:
                                            row.contactPerson1PhoneNumber,
                                          contactPerson1Email:
                                            row.contactPerson1Email,
                                          contactPerson2Name:
                                            row.contactPerson2Name,
                                          contactPerson2PhoneNumber:
                                            row.contactPerson2PhoneNumber,
                                          contactPerson2Email:
                                            row.contactPerson2Email,
                                          contactPerson3Name:
                                            row.contactPerson3Name,
                                          contactPerson3PhoneNumber:
                                            row.contactPerson3PhoneNumber,
                                          contactPerson3Email:
                                            row.contactPerson3Email,
                                          contactPerson4Name:
                                            row.contactPerson4Name,
                                          contactPerson4PhoneNumber:
                                            row.contactPerson4PhoneNumber,
                                          contactPerson4Email:
                                            row.contactPerson4Email,
                                          contactPerson5Name:
                                            row.contactPerson5Name,
                                          contactPerson5PhoneNumber:
                                            row.contactPerson5PhoneNumber,
                                          contactPerson5Email:
                                            row.contactPerson5Email,
                                          latittude: row.latittude,
                                          longitude: row.longitude,
                                          landlineNumber: row.landlineNumber,
                                        };
                                        setSelectedEmployer(tempEmployer);
                                        setOpenRestoreConfirmation(true);
                                      }}
                                    >
                                      <SettingsBackupRestoreIcon fontSize="inherit" />
                                    </IconButton>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Delete">
                                    <IconButton
                                      color="error"
                                      size="small"
                                      onClick={() => {
                                        let tempEmployer = {
                                          id: row.id,
                                          name: row.name,
                                          email: row.email,

                                          phoneNumber: row.phoneNumber,
                                          addressLine1: row.addressLine1,
                                          addressLine2: row.addressLine2,
                                          city: row.city,
                                          taluka: row.taluka,
                                          district: row.district,
                                          state: row.state,
                                          pinCode: row.pinCode,
                                          website: row.website,
                                          createDate: convertDateToLocalReverse(
                                            row.createDate
                                          ),
                                          modifiedDate:
                                            convertDateToLocalReverse(
                                              row.modifiedDate
                                            ),
                                          isDeleted: row.isDeleted,
                                          deleteDate: convertDateToLocalReverse(
                                            row.deleteDate
                                          ),
                                          canDelete: row.canDelete,
                                          gradeType: row.gradeType,
                                          contactPerson1Name:
                                            row.contactPerson1Name,
                                          contactPerson1PhoneNumber:
                                            row.contactPerson1PhoneNumber,
                                          contactPerson1Email:
                                            row.contactPerson1Email,
                                          contactPerson2Name:
                                            row.contactPerson2Name,
                                          contactPerson2PhoneNumber:
                                            row.contactPerson2PhoneNumber,
                                          contactPerson2Email:
                                            row.contactPerson2Email,
                                          contactPerson3Name:
                                            row.contactPerson3Name,
                                          contactPerson3PhoneNumber:
                                            row.contactPerson3PhoneNumber,
                                          contactPerson3Email:
                                            row.contactPerson3Email,
                                          contactPerson4Name:
                                            row.contactPerson4Name,
                                          contactPerson4PhoneNumber:
                                            row.contactPerson4PhoneNumber,
                                          contactPerson4Email:
                                            row.contactPerson4Email,
                                          contactPerson5Name:
                                            row.contactPerson5Name,
                                          contactPerson5PhoneNumber:
                                            row.contactPerson5PhoneNumber,
                                          contactPerson5Email:
                                            row.contactPerson5Email,
                                          latittude: row.latittude,
                                          longitude: row.longitude,
                                          landlineNumber: row.landlineNumber,
                                        };
                                        setSelectedEmployer(tempEmployer);
                                        setOpenDelete(true);
                                      }}
                                    >
                                      <DeleteIcon fontSize="inherit" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
              ) : (
                <Box sx={{ padding: 2 }}>
                  <Typography variant="h5" color="textSecondary">
                    {checked ? <NoDataFound /> : <NoDataFound />}
                  </Typography>
                </Box>
              )
            ) : (
              <Box
                sx={{ display: "flex", justifyContent: "center", marginY: 5 }}
              >
                <Stack
                  direction="column"
                  spacing={3}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography variant="h5" textAlign="center">
                    Loading Employers...
                  </Typography>
                  <CircularProgress />
                </Stack>
              </Box>
            )}
          </Grid>
          <Grid item xs={12}>
            {employers != undefined ? (
              <Box
                sx={{
                  paddingX: 2,
                  marginBottom: 2,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Pagination
                  count={Math.ceil(employers.count / pageSize)}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                  color="primary"
                  sx={{ marginTop: 2 }}
                  onChange={(event, page) => {
                    getEmployers((page - 1) * pageSize);
                  }}
                />
              </Box>
            ) : null}
          </Grid>
        </Grid>
      </Card>

      {/* Employer form dialog */}
      <Dialog
        open={openEmployerForm}
        onClose={() => {
          setOpenEmployerForm(false);
        }}
        fullWidth
        maxWidth="md"
      >
        <DialogContent>
          <EmployerForm
            employer={selectedEmployer}
            onSave={() => {
              getEmployers(0);
              setOpenEmployerForm(false);
            }}
            onCancel={() => {
              setOpenEmployerForm(false);
            }}
          />
        </DialogContent>
      </Dialog>

      {/* Delete dialog */}
      <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth>
        <DialogTitle>Delete Employer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this employer ?{" "}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} variant="contained">
            Yes
          </Button>
          <Button onClick={handleCancelDelete} variant="outlined">
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* Restore dialog */}
      <Dialog
        open={openRestoreConfirmation}
        onClose={() => {
          setOpenRestoreConfirmation(false);
        }}
        fullWidth
      >
        <DialogTitle>Restore Employer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to restore this employer ?{" "}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRestore} variant="contained">
            Yes
          </Button>
          <Button
            onClick={() => {
              setOpenRestoreConfirmation(false);
            }}
            variant="outlined"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default Employers;
